import {
  BaseFormElementData,
  BaseFormElementModel,
  BaseFormElementSettingsData,
  BaseFormElementState
} from '@/components/addons/registration/BaseFormElementModel';

export interface FormElementLocationSettingsData extends BaseFormElementSettingsData {
  field_mapping: {
    shop_address: string;
    shop_city: string;
    shop_country: string;
    shop_id: string;
    shop_name: string;
    shop_po: string;
  };
}

interface Place {
  name: string;
  place_id: string;
}

interface City {
  id: string;
  name: string;
  places: Place[];
}

interface OptionData {
  cities: City[];
  id: string;
  name: string;
}

export interface FormElementLocationData extends BaseFormElementData {
  settings?: FormElementLocationSettingsData;
  options: OptionData[];
}

interface MappedItem {
  [key: string]: string;
}

export interface FormElementLocationState extends BaseFormElementState<MappedItem> {
  options: OptionData[];
  fieldMapping?: {
    shopAddress?: string;
    shopCity?: string;
    shopCountry?: string;
    shopId?: string | number;
    shopName?: string;
    shopPo?: string;
  };
}

export class FormElementLocationModel extends BaseFormElementModel<
  MappedItem,
  FormElementLocationData,
  FormElementLocationState
> {
  parseFormElement(data: FormElementLocationData) {
    this.state.options = data.options;

    this.state.fieldMapping = this.state.fieldMapping ?? {
      shopAddress: '',
      shopId: '',
      shopCity: '',
      shopCountry: '',
      shopName: '',
      shopPo: ''
    };
    if (data.settings?.field_mapping?.shop_address) {
      this.state.fieldMapping.shopAddress = data.settings?.field_mapping?.shop_address;
    } else {
      this.state.fieldMapping.shopAddress = '';
    }
    if (data.settings?.field_mapping?.shop_city) {
      this.state.fieldMapping.shopCity = data.settings?.field_mapping?.shop_city;
    } else {
      this.state.fieldMapping.shopCity = '';
    }
    if (data.settings?.field_mapping?.shop_country) {
      this.state.fieldMapping.shopCountry = data.settings?.field_mapping?.shop_country;
    } else {
      this.state.fieldMapping.shopCountry = '';
    }
    if (data.settings?.field_mapping?.shop_id) {
      this.state.fieldMapping.shopId = data.settings?.field_mapping?.shop_id;
    } else {
      this.state.fieldMapping.shopId = '';
    }
    if (data.settings?.field_mapping?.shop_name) {
      this.state.fieldMapping.shopName = data.settings?.field_mapping?.shop_name;
    } else {
      this.state.fieldMapping.shopName = '';
    }
    if (data.settings?.field_mapping?.shop_po) {
      this.state.fieldMapping.shopPo = data.settings?.field_mapping?.shop_po;
    } else {
      this.state.fieldMapping.shopPo = '';
    }
  }

  getInitialValue(): MappedItem | undefined {
    return this.parseStringValue(this.getInitialStringValue() ?? '');
  }

  getStringifiedValue(): string | undefined {
    return this.state.value ? JSON.stringify(this.state.value) : undefined;
  }

  parseStringValue(value: string): MappedItem | undefined {
    if (value && value[0] === '{') {
      return JSON.parse(value) as MappedItem;
    }

    return undefined;
  }

  getSerializedPostValue(): MappedItem | undefined {
    return this.state.value ?? undefined;
  }

  getSerializedCookieValue(): string {
    return this.state.value ? JSON.stringify(this.state.value) : '';
  }

  authorSignature(): string {
    return 'Nicky Christensen';
  }
}
